<template>
  <div class="nlp-pricing-v2">
    <div class="nlp-pricing-v2__container">
      <div class="nlp-pricing-v2__header">
        <div class="nlp-pricing-v2__title">
          Pricing
        </div>
        <div class="nlp-pricing-v2__subtitle">
          Find a plan that fits your needs
        </div>
      </div>
      <div class="nlp-pricing-v2__select">
        <GlSelectButton
          gray-padding="wide"
          grey
          :options="computedPlanTypes"
          :value="activeCycle"
          @input="typeChange"
        />
      </div>

      <div class="nlp-pricing-v2__cards">
        <div v-if="getPlansLoading">
          <gl-loader />
        </div>
        <PlanCard
          v-for="item in getPlans"
          v-else
          :key="item.id"
          :active-cycle="activeCycle"
          :item="item"
          @onBuyClick="onBuyClick"
          @onExampleClick="onExampleClick"
        />
      </div>
    </div>
  </div>
</template>

<script>
// Components
import GlLoader from '@/components/gl-loader'
import PlanCard from '@/pages/report/components/purchase/PlanCard'
import GlSelectButton from '@/components/gl-select-button2.vue'
// utils
import { openExample, openProfilePlan } from '@/utils/go-to-route'
import {
  billingCycle,
  getAnnualSaveDiff,
  getPlanOptionsWithProfit,
} from '@/utils/plans'
// vuex
import { mapGetters } from 'vuex'

export default {
  name: 'NlpPricingV2',
  components: { PlanCard, GlLoader, GlSelectButton },
  data() {
    return {
      activeCycle: null,
      billingCycle,
    }
  },
  computed: {
    ...mapGetters('payment', ['getPlans', 'getPlansLoading']),
    computedPlanTypes() {
      const diff = getAnnualSaveDiff(this.getPlans || [])
      return getPlanOptionsWithProfit(this.billingCycle, diff)
    },
  },
  created() {
    this.activeCycle = this.billingCycle.find(cycle => cycle.value)
  },
  methods: {
    openExample,
    onBuyClick(item) {
      if (!item) return
      openProfilePlan({
        planTier: item.planTier,
        billingCycle: item.billingCycle,
        isTrialRequest: item.isTrialRequest,
      })
    },
    onExampleClick(value) {
      this.openExample(value)
    },
    typeChange(type) {
      this.activeCycle = type
    },
  },
}
</script>

<style scoped>
.nlp-pricing-v2 {
  width: 100%;
}
.nlp-pricing-v2__container {
  display: flex;
  flex-direction: column;
  gap: 32px;
}

.nlp-pricing-v2__header {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.nlp-pricing-v2__title {
  color: var(--Basic-900, #091540);
  text-align: center;
  font-size: 44px;
  font-weight: 900;
  line-height: 58px;
}
.nlp-pricing-v2__subtitle {
  color: var(--Grey, #5a627d);
  text-align: center;
  font-size: 18px;
  font-weight: 400;
  line-height: 26px;
}

.nlp-pricing-v2__select {
  display: flex;
  justify-content: center;
  margin-top: 10px;
}

.nlp-pricing-v2::v-deep .gl-select-button__item,
.nlp-pricing-v2::v-deep .plan-card--popular-mask {
  font-weight: 700;
}

.nlp-pricing-v2__cards {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 32px;
  position: relative;
  word-break: break-word;
  padding-top: 36px;
}

.nlp-pricing-v2__cards::v-deep .plan-card {
  width: 356px;
}

.nlp-pricing-v2::v-deep .plan-card__title,
.nlp-pricing-v2::v-deep .pricing-text__highlighted {
  font-weight: 900;
}

.nlp-pricing-v2::v-deep .plan-card__sub-title {
  align-self: stretch;
  color: var(--Black, #1c1c1c);
  font-size: 16px;
  font-weight: 400;
  line-height: 26px;
}

.nlp-pricing-v2::v-deep .button__buy,
.nlp-pricing-v2::v-deep .plan-card__includes-label,
.nlp-pricing-v2::v-deep .button__example-text {
  font-weight: 700;
}

.nlp-pricing-v2::v-deep .plan-card__includes-item,
.nlp-pricing-v2::v-deep .button__example-text {
  letter-spacing: 0;
}

.nlp-pricing-v2::v-deep .gl-select-button-wrapper {
  width: auto;
}

.nlp-pricing-v2::v-deep .button__buy,
.nlp-pricing-v2::v-deep .button__example {
  border-radius: 100px;
}

@media (max-width: 830px) {
  .nlp-pricing-v2__cards {
    flex-direction: column;
    align-items: center;
    gap: 24px;
    padding-top: 0px;
  }
  .nlp-pricing-v2__cards .plan-card:has(.plan-card--popular-mask) {
    margin-top: 36px;
    margin-bottom: 8px;
  }
}
@media (max-width: 430px) {
  .nlp-pricing-v2 {
    padding-right: 16px;
    padding-left: 16px;
  }
  .nlp-pricing-v2__cards .plan-card {
    width: 100%;
  }
}
</style>
